const doc = [({"da":({"js":({"shared":({"amount_of_months":"%{amount} mdr."})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;